import React from 'react';
import { Routes, Route } from 'react-router-dom';
import LoadingFlexView from './LoadingFlexView';
import LoadingBuildView from './LoadingBuildView';
import LoadingSummaryView from './LoadingSummaryView';

const Loading = () => {
  return (
    <>
      <Routes>
        <Route path="config/*" element={<LoadingFlexView />} />
        <Route path="trims/*" element={<LoadingFlexView />} />
        <Route
          path="exterior/*"
          element={<LoadingBuildView isExterior={true} />}
        />
        <Route path="wheels/*" element={<LoadingBuildView />} />
        <Route path="interior/*" element={<LoadingBuildView />} />
        <Route
          path="packages/*"
          element={<LoadingFlexView step="packages" />}
        />
        <Route path="options/*" element={<LoadingFlexView step="options" />} />
        <Route path="summary/*" element={<LoadingSummaryView />} />
        <Route path="*" element={<LoadingFlexView />} />
      </Routes>
    </>
  );
};

export default Loading;
